import React, { FC } from 'react';
import SoftwareHeader from 'evcharging/containers/ev-software/SoftwareHeader';
import Navigation from 'evcharging/containers/layout/Navigation';
import Page from 'evcharging/components/Page';
import { createGetServerSideProps, StaticPageProps } from 'evcharging/app';
import Footer from 'evcharging/containers/layout/Footer';
import RequestConsultation from 'evcharging/containers/layout/RequestConsultation';
import EvApp from 'evcharging/containers/ev-software/EvApp';
import { EV_SOFTWARE_LINK } from 'evcharging/app/seo/pages';
import FaqSection from 'evcharging/containers/layout/FaqSection';
import StayUpdated from 'evcharging/containers/layout/StayUpdated';
import WebMobileApp from 'evcharging/containers/ev-software/WebMobileApp';
import Support from 'evcharging/containers/ev-software/Support';
import StreamlinedCharging from 'evcharging/containers/ev-software/StreamlinedCharging';
import { I18nPage } from 'i18n/types/pages.enum';

const EvSoftware: FC<StaticPageProps> = ({ page }) => (
  <Page
    locales={page.locales}
    title={page.meta_title}
    description={page.meta_description}
  >
    <Navigation />
    <SoftwareHeader />
    <WebMobileApp />
    <StreamlinedCharging />
    <Support />
    <EvApp />
    <RequestConsultation />
    <FaqSection faqs={page.faqs} />
    <StayUpdated />
    <Footer />
  </Page>
);

export const getServerSideProps = createGetServerSideProps(
  EV_SOFTWARE_LINK,
  undefined,
  [I18nPage.EvChargingCommon, I18nPage.EvChargingSoftware, I18nPage.EnergyRates]
);

export default EvSoftware;
